import sdl from '@jds/react-generated-sdl/JDSSidePanel';
import type { JDSSidePanelProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SidePanelProps } from '../logic';

const Component = (props: SidePanelProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    direction = 'left',
    showClose = true,
    open = false,
    maxWidth = false,
    disableTransition = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { direction, showClose, open, maxWidth, disableTransition, ...rest },
    'JDSSidePanel',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SidePanel = withLogic(Component) as React.FC<SidePanelProps> & {
  slotName?: string;
};

SidePanel.displayName = 'SidePanel';
SidePanel.slotName = 'jds_side_panel';

export { SidePanel, type JDSSidePanelProps };
